import type { LucideIcon } from "lucide-react";

export function FeatureCard({
  icon: Icon,
  title,
  body,
}: {
  icon: LucideIcon;
  title: string;
  body: string;
}) {
  return (
    <div className="rounded-card border border-border bg-navy-card p-6">
      <Icon className="h-5 w-5 text-cyan" strokeWidth={1.6} />
      <h3 className="mt-4 font-display text-base font-semibold text-text-primary">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-text-secondary">{body}</p>
    </div>
  );
}
